import ContentLoading from "component/LoadingComponent/ContentLoading";
import InnerHeader from "component/shared/innerheader/InnerHeader";
import { END_POINTS } from "constants/APIConstant";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";

import DropDownSearchComponent from "component/dropdownSearchComponent";
import CustomizedSearchPage from "pages/customizedSearchPageComponent";
import { useEffect, useState } from "react";
// import ReactGA from "react-ga4";

const SubjectSearch = () => {
  const { id } = useParams();
  const intl = useIntl();
  const navigate = useNavigate();

  const [allSubjects, setAllSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);

  //Get Subjects to get the name
  const subjectsFetching = useSWR({
    url: END_POINTS.SUBJECTS,
  });

  useEffect(() => {
    if (
      !subjectsFetching.error ||
      !subjectsFetching.isLoading ||
      subjectsFetching.data !== undefined
    ) {
      const subjects = subjectsFetching.data?.data?.flatMap(
        (subject, index) => {
          const subSubjects = subject.subSubjects;
          return subSubjects.map((subSubject, index) => {
            return {
              id: subSubject.id,
              title: subSubject.title,
              subjectTranslations: subSubject.subjectTranslations,
            };
          });
        }
      );
      setAllSubjects(subjects);
      const currentSubject = subjects?.find((x) => x.id === +id);
      setSelectedSubject(currentSubject);
    }
  }, [subjectsFetching.isLoading]);

  const subjectResultData = useSWR({
    url: `${END_POINTS.SUBJECT_SEARCH}`,
    params: { subjectId: id },
  });
  const getObjectWithKey = ({ objKey }) => {
    const obj =
      subjectResultData.error ||
      subjectResultData.isLoading ||
      subjectResultData.data === undefined
        ? []
        : subjectResultData.data.data[objKey];
    return obj;
  };

  const onChange = (e) => {
    const { value } = e.target;
    const currentSubject = allSubjects?.find((x) => x.id === +value);
    setSelectedSubject(currentSubject);
    navigate(`/subject/search/${value}`);
  };

  // ReactGA.initialize(END_POINTS.TRACKING_ID);

  // useEffect(() => {
  //   // Send pageview with a custom path
  //   ReactGA.send({
  //     hitType: "pageview",
  //     page: `/subject/search/${id}`,
  //     title: `Publication: ${dataFetching.data?.data?.name}`
  //   });
  // }, [id]);

  return (
    <div className="subject-search">
      <InnerHeader
        breadcrumb={[
          {
            title: <FormattedMessage id="search-according-subject" />,
            clickClass: true,
          },
        ]}
        title={intl.formatMessage({ id: "search-according-subject-result" })}
      />
      <div className="container">
        <DropDownSearchComponent value={id} onChange={onChange} />
      </div>
      <ContentLoading
        isLoading={subjectResultData.isLoading}
        className="advanced-search"
      >
        <CustomizedSearchPage
          subject={selectedSubject}
          indicators={getObjectWithKey({ objKey: "indicators" })}
          mainSubjectId={getObjectWithKey({
            objKey: "mainSubjectId",
          })}
          subSubjectId={id}
          publications={getObjectWithKey({ objKey: "publications" })}
          news={getObjectWithKey({ objKey: "news" })}
          infographics={getObjectWithKey({ objKey: "infographic" })}
          renderNewsTitleOnly={false}
        />
      </ContentLoading>
    </div>
  );
};
export default SubjectSearch;
